import { configureStore } from '@reduxjs/toolkit';
import authReducer from './authReducer'; // Adjust the import path if necessary
import exchangeSportsReducer from './exchangeSports/exchangeSportsReducer';
import exchBetSlipReducer from './exchBetSlip/exchBetSlipReducer';
import tokenReducer from './token/tokenReducer';

export const store = configureStore({
  reducer: {
    userDetails: authReducer,
    exchangeSports: exchangeSportsReducer,
    exchBetSlip: exchBetSlipReducer,
    auth: tokenReducer,
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
export const dispatch = store.dispatch;

export default store;
